var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wt-tags-list-item",class:{
    'tag-display-none': _vm.shouldHideTag,
  },on:{"click":function($event){$event.stopPropagation();}}},[_c('span',{attrs:{"title":_vm.showTitle ? _vm.tag.label : ''}},[_vm._v(_vm._s(_vm.tag.label))]),_vm._v(" "),_c('i',{staticClass:"tag-close wticon wticon-close",on:{"click":function($event){return _vm.onRemove($event, _vm.tag.id)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }